<template>
  <v-app id="inspire">
    <navigation-drawer v-model="drawer" :items="items" :mini="miniMenu"></navigation-drawer>
    <app-bar
      :items_menu="items_menu"
      :nome="nome"
      :empresa="empresa"
      :isInadimplente="isInadimplente"
      :show-trocar-empresa="hasMultiEmpresa"
      @emit-drawer="getDrawer"
      @trocar-empresa="dialogTrocarEmpresa = true"
    />
    <trocar-empresa-dialog
      v-model="dialogTrocarEmpresa"
      @empresa-alterada="onEmpresaAlterada"
    />

    <v-main class="stone-main">
      <div class="stone-main__content">
        <div
          v-if="showAccessGateBanner && !['Cadastro de Credor', 'Cadastro de Credores'].includes($route.name)"
          class="access-gate-banner"
        >
          <v-icon color="#0052A0" size="22" class="access-gate-banner__icon">mdi-domain</v-icon>
          <div class="access-gate-banner__text">
            <div class="access-gate-banner__title">Acesso ainda não liberado</div>
            <div class="access-gate-banner__body">
              Complete o cadastro da sua empresa para liberar as funcionalidades da plataforma. Se você já
              enviou os dados, seu cadastro está em análise pela nossa equipe e o acesso é liberado
              automaticamente assim que a validação terminar.
            </div>
          </div>
          <v-btn
            color="#0052A0"
            rounded
            elevation="0"
            small
            class="access-gate-banner__cta px-4"
            @click="NavigateTo('Cadastro de Credores')"
          >
            <span style="color:#FFD400;font-weight:700;font-size:12px">Ver cadastro</span>
          </v-btn>
        </div>
        <router-view :key="routerKey" />
      </div>
      <v-dialog v-model="inadimplenteDialogShow" max-width="600">
        <v-sheet class="pa-4 text-center mx-auto" elevation="12" max-width="600" rounded="lg" width="100%">
          <v-icon class="mb-5" color="error" size="112">mdi-alert</v-icon>

          <h2 class="text-h5 mb-6">Faturas em aberto</h2>

          <p class="mb-4 text-medium-emphasis text-body-2">
            Prezado cliente, identificamos faturas pendentes no seu plano. Solicitamos a regularização do pagamento para
            evitar a suspensão do seu acesso à plataforma.
            <br><br>
            Agradecemos pela sua atenção.
            <br>
            Atenciosamente, equipe StoneUp.
          </p>

          <v-divider class="mb-4"></v-divider>

          <div class="text-end">
            <v-btn class="text-none" color="success" @click="inadimplenteDialogShow = false" variant="flat" width="90"
              rounded>
              Fechar
            </v-btn>
          </div>
        </v-sheet>
      </v-dialog>

      <v-dialog v-model="dialogWhatsapp" content-class="my-custom-dialog" max-width="300">
        <v-card>
          <v-toolbar color="green dense">
            <v-row>
              <v-col cols="2">
                <v-avatar color="#ffffff" class="border" size="40">
                  <v-img src="../assets/SVG/monitora-icone.svg" contain max-width="32"></v-img>
                </v-avatar>
              </v-col>
              <v-col cols="10">
                <h3 class="white--text">Equipe StoneUp</h3>
                <h5 class="white--text">SAC:{{ telefone }}</h5>

                <v-btn fab dark small @click="dialogWhatsapp = false" style="
                    position: fixed;
                    right: 2px;
                    top: 2px;
                    width: 15px;
                    height: 15px;
                  "><v-icon small>mdi-close</v-icon></v-btn>
              </v-col>
            </v-row>
          </v-toolbar>
          <v-card-text>
            <v-row>
              <div style="height: 180px; width: 100%; margin-top: 25px">
                <v-chip style="width: 90%">Fale conosco!</v-chip>
                <div style="margin-top: 15px">
                  <v-textarea v-model="textoMensagem" height="115" full-width style="width: 85%" filled rounded dense>
                  </v-textarea>
                  <v-btn style="position: absolute; bottom: 35px; right: 2px" small @click="enviarMensagem()"
                    color="success"><v-icon small>mdi-send</v-icon></v-btn>
                </div>
              </div>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-btn color="green" @click="exibirWhats()" style="
          position: fixed;
          bottom: 25px;
          right: 25px;
          display: inline-block;
        " fab><v-icon color="white">mdi-whatsapp</v-icon>
      </v-btn>

    </v-main>
    <footer-stone> </footer-stone>
  </v-app>
</template>

<script>
import NavigationDrawer from "../containers/layout/NavigationDrawer";
import { mapActions } from "vuex";
import AppBar from "../containers/layout/AppBar";
import FooterStone from "../containers/layout/FooterStone";
import TrocarEmpresaDialog from "@/components/TrocarEmpresaDialog.vue";

export default {
  components: { NavigationDrawer, AppBar, FooterStone, TrocarEmpresaDialog },
  name: "Dashboard",
  data: () => ({
    drawer: false,
    miniMenu: false,
    empresa: "",
    isInadimplente: "",
    dialogWhatsapp: false,
    textoMensagem: null,
    ambiente: null,
    telefone: null,
    items_menu: [],
    items: [],
    nome: "",
    routerKey: 0,
    inadimplenteDialogShow: false,
    dialogTrocarEmpresa: false,
    showAccessGateBanner: false,
  }),

  computed: {
    hasMultiEmpresa() {
      const u = this.$store.state.auth.user;
      return u && Array.isArray(u.empresas) && u.empresas.length > 1;
    },
  },

  methods: {
    ...mapActions("auth", ["ActionSignOut"]),
    async sair() {
      try {
        await this.ActionSignOut();
        this.$router.push({ name: "login" });
      } catch (error) {
        alert(
          error.data ? error.data.message : "Não foi possivel sair do sistema"
        );
      }
    },
    exibirWhats() {
      this.dialogWhatsapp = true;
    },
    carregarNumero() {
      this.$http.get("suportetelefone").then((response) => {
        this.telefone = response.body;
      });
    },
    enviarMensagem() {
      window.open(
        `https://api.whatsapp.com/send?phone=${this.telefone}&text=${this.textoMensagem}`,
        "_blank"
      );
      this.textoMensagem = null;
      this.dialogWhatsapp = false;
    },
    NavigateTo(where) {
      this.$router.push({ name: where });
    },
    onEmpresaAlterada() {
      const u = this.$store.state.auth.user;
      if (u && u.domain) {
        this.isInadimplente = u.domain.status_financeiro || "";
        this.empresa = (u.domain.name || "") + "  - " + (u.domain.cpf_cnpj || "");
        if (u.domain.status_financeiro == "INADIMPLENTE") {
          this.inadimplenteDialogShow = true;
        }
      }
      this.items = (u && u.menu) || [];
      this.showAccessGateBanner = this.items.length === 0;
      this.routerKey++;
    },
    getDrawer() {
      // md+: menu fixo, o botão alterna o modo recolhido. Abaixo: gaveta sobreposta.
      if (this.$vuetify.breakpoint.mdAndUp) {
        this.miniMenu = !this.miniMenu;
      } else {
        this.drawer = !this.drawer;
      }
    },
  },
  watch: {
    $route() {
      if (this.$vuetify.breakpoint.smAndDown) this.drawer = false;
    },
  },
  mounted() {
    const u = this.$store.state.auth.user;
    this.nome = u.name || '';
    this.ambiente = u.ambiente || '';

    if (u.domain) {
      this.isInadimplente = u.domain.status_financeiro || '';
      this.empresa = (u.domain.name || '') + "  - " + (u.domain.cpf_cnpj || '');
      if (u.domain.status_financeiro == "INADIMPLENTE") {
        this.inadimplenteDialogShow = true;
      }
    }
  },
  created() {
    // Entre 960 e 1263px o menu abre recolhido para sobrar espaço ao conteúdo
    this.miniMenu = this.$vuetify.breakpoint.mdOnly;
    this.carregarNumero();
    if (this.$store.state.auth.user && this.$store.state.auth.user.menu && this.$store.state.auth.user.menu.length > 0) {
      this.items = this.$store.state.auth.user.menu;
    } else {
      this.showAccessGateBanner = true;
      if (this.$route.name !== "Cadastro de Credores") {
        this.$router.push({ name: "Cadastro de Credores" });
      }
    }
  },
};
</script>

<style>
.bold {
  font-weight: 700;
}

h3 {
  color: #0066ff !important;
  font-family: "Inter";
}

.stone-main {
  background: #f4f6f9 !important;
  padding: 8px 12px 16px !important;
  /* ocupa a tela toda abaixo do app-bar (64px) e acima da faixa de ambiente (25px),
     senão o fundo cinza termina no meio da tela em páginas curtas */
  min-height: calc(100vh - 89px);
}
@media (max-width: 959px) {
  /* app-bar do Vuetify tem 56px em sm e abaixo */
  .stone-main { min-height: calc(100vh - 81px); }
}
@media (max-width: 768px) {
  /* no celular as páginas já têm padding próprio de 16px; o quadro cinza só rouba espaço */
  .stone-main { padding: 0 !important; }
  .stone-main__content { margin-top: 0; }
}

.stone-main__route-title {
  margin: 8px 0 0 8px;
  color: #2a3242 !important;
  font-size: 24px;
  font-weight: 700;
}

.stone-main__content {
  margin-top: 8px;
  /* folga para o FAB do WhatsApp não cobrir paginação/botões no fim da página */
  padding-bottom: 72px;
}

.access-gate-banner {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  background: #eef4fc;
  border: 1px solid #d9e6f7;
  border-radius: 10px;
  padding: 14px 18px;
  margin-bottom: 16px;
}
.access-gate-banner__icon {
  flex-shrink: 0;
  margin-top: 2px;
}
.access-gate-banner__text {
  flex: 1;
  min-width: 200px;
}
.access-gate-banner__title {
  font-family: "Inter", sans-serif;
  font-size: 0.92rem;
  font-weight: 700;
  color: #0052a0;
  margin-bottom: 4px;
}
.access-gate-banner__body {
  font-family: "Inter", sans-serif;
  font-size: 0.82rem;
  color: #475569;
  line-height: 1.55;
}
.access-gate-banner__cta {
  flex-shrink: 0;
  align-self: center;
  font-family: "Inter", sans-serif !important;
  font-weight: 700 !important;
  text-transform: none;
  border-radius: 8px !important;
  white-space: nowrap;
}
@media (max-width: 600px) {
  .access-gate-banner {
    flex-direction: column;
  }
  .access-gate-banner__cta {
    align-self: stretch;
  }
}

.v-card__title {
  color: white !important;
  background-color: #026ea7;
  font-family: "Inter";
  font-weight: 700;
}

.v-select.v-input--dense .v-select__selection--comma {
  color: #0052a0;
  font-weight: 600;
}

.swal2-styled.swal2-confirm {
  border: 0;
  border-radius: 45px;
  width: 150px;
  font-family: "Inter";
  font-weight: 600;
  background-color: #2778c4;
  color: #ffd400;
  font-size: 1.0625em;
  margin-right: 7.5px;
  margin-left: 7.5px;
  height: 35px;
  letter-spacing: 0.25px;
  min-width: 130px;
}

.swal2-confirm.btn.btn-success {
  background-color: #0052a0;
  color: #ffd400;
  font-family: "Inter";
  font-weight: 600;
  margin-right: 7.5px;
  margin-left: 7.5px;
  height: 35px;
  letter-spacing: 0.25px;
  min-width: 130px;
  border-radius: 30px;
}

.swal2-styled.swal2-cancel {
  background-color: #ffd400;
  color: #0052a0;
  font-family: "Inter";
  font-weight: 600;
  margin-right: 7.5px;
  margin-left: 7.5px;
  height: 35px;
  letter-spacing: 0.25px;
  min-width: 130px;
  border-radius: 30px;
}

.my-custom-dialog {
  bottom: 0 !important;
  right: 0 !important;
  position: absolute !important;
}

.swal2-cancel {
  background-color: #ffd400;
  color: #0052a0;
  font-family: "Inter";
  font-weight: 600;
  margin-right: 7.5px;
  margin-left: 7.5px;
  height: 35px;
  letter-spacing: 0.25px;
  min-width: 130px;
  border-radius: 30px;
}

.swal2-html-container {
  font-family: "Inter";
  font-weight: 600;
}

.swal2-title {
  font-family: "Inter";
  color: #0052a0;
  font-weight: 600;
}

.color_back {
  background: -webkit-linear-gradient(to right, #232526, #414345);
  background: linear-gradient(to right, #232526, #414345);
}

.color_active {
  color: #026ea7 !important;
  font-size: 0.875rem !important;
}

.txt_sombra {
  text-shadow: 0 0 1px #fff, 0 0 1px #fff, 0 0 1px #fff, 0 0 1px #fff,
    0 0 1px #fff, 0 0 1px #fff, 0 0 1px #fff, 0 1px 2px rgb(0 0 0 / 30%),
    0 3px 9px rgb(0 0 0 / 10%);
}

.txt_sombra_black {
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.507);
}

.v-application--wrap {
  flex: 1 1 auto;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  display: flex;
  flex-direction: column;
  min-height: 100% !important;
  max-width: 100%;
  position: relative;
}

.v-text-field {
  font-family: "Inter";
}

.card-stone-background {
  background-color: #cee2ef;
  color: #026ea7;
}

.card__text .card-stone-background {
  background-color: #cee2ef;
  color: #026ea7;
}

.theme--light.v-subheader {
  color: #026ea7;
  font-family: "Inter";
  font-weight: 600;
}

.degrade {
  background: linear-gradient(90deg,
      #f9a800 0.06%,
      #f27c00 47.93%,
      #ffd400 100%);
}

.degrade_stone {
  background: linear-gradient(90deg,
      #046fd3 0.06%,
      #0052a0 47.93%,
      #013668 100%);
}

.ativo {
  background-color: #f6f6f6;
}

.cinza {
  background-color: #212121;
}

.border {
  padding: 2px;
  background-color: #ffd400 !important;
}

.v-btn {
  border-radius: 30px;
  font-family: "Inter";
}

.v-btn-stn-orange {
  border-radius: 30px;
  font-family: "Inter";
  background-color: #ffa900;
  color: #0052a0;
}

.v-container {
  font-family: 'Inter', sans-serif;
  max-width: 100% !important;
}

.text-start {
  font-family: "Inter";
  font-weight: 600;
  color: red;
}

/* ─── v-data-table: padrão corporativo (neutro, sem colunas "listradas") ─── */
.v-data-table-header {
  background-color: #fafafa;
  font-family: "Inter", sans-serif;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.6);
}

.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  background-color: #fafafa !important;
  color: rgba(0, 0, 0, 0.54) !important;
  font-weight: 600 !important;
  font-size: 0.75rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;
}

.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:not(.v-data-table__expanded__content):hover {
  background-color: rgba(0, 0, 0, 0.04) !important;
}

.v-data-table table th + th,
.v-data-table table td + td {
  border-left: none !important;
}

.v-data-table tbody td {
  color: rgba(0, 0, 0, 0.87);
  font-weight: 400;
}

.v-data-table tbody tr span {
  color: inherit;
}

/* botão desabilitado: o texto/ícone amarelo inline (#FFD400) do padrão visual
   sobrepunha o cinza do Vuetify e ficava ilegível sobre o fundo cinza */
.v-btn.v-btn--disabled span[style*="FFD400"],
.v-btn.v-btn--disabled span[style*="255, 212, 0"],
.v-btn.v-btn--disabled .v-icon {
  color: rgba(0, 0, 0, 0.38) !important;
}

/* tabelas no modo celular (Vuetify vira "cards"): separa um registro do outro */
.v-data-table__mobile-table-row > td:last-child {
  border-bottom: 6px solid #f1f5f9 !important;
}
.v-data-table__mobile-row__header {
  font-weight: 600;
  color: #64748b;
  font-size: 0.78rem;
}

.theme--light.v-input input,
.theme--light.v-input textarea {
  font-size: 13px;
  color: #0052a0;
  font-weight: 600;
  font-family: "Inter";
  letter-spacing: 0.19px;
}

.v-select__selections {
  font-family: "Inter";
  color: #0052a0;
  font-weight: 600;
  font-size: 13px;
}

.theme--light.v-label {
  color: #0052a0;
}

.theme--light.v-select .v-select__selections {
  font-family: "Inter";
  color: #0052a0;
  font-weight: 600;
}

.theme--light.v-stepper .v-stepper__label {
  font-family: "Inter";
  color: #0052a0;
  font-weight: 600;
}

.v-input__control .v-input__slot {
  background: white;
}

.v-stepper__step .v-stepper__step--inactive {
  color: #0052a0;
}

.v-stepper__step__step .orange {
  background-color: #0052a0;
}

.v-data-footer {
  color: rgba(0, 0, 0, 0.54);
}

.v-text-field.v-text-field:not(.v-text-field-flat, .v-data-footer__select *)>.v-input__control>.v-input__slot {
  box-shadow: none !important;
  min-height: 36px;
  color: #2778c4;
}

.v-input--checkbox>.v-input__control>.v-input__slot {
  background-color: transparent;
}
</style>
